import { SectionHeading } from './SectionHeading'

const COMPANY_INFO = [
  { label: '社名', value: '株式会社ジェイフロンティア（J-Frontier Co.,Ltd.）' },
  {
    label: '住所',
    value: '〒169-0075 東京都新宿区高田馬場1丁目31-7 ソアブール高田馬場2F'
  },
  { label: '代表取締役', value: '岡本 博' },
  { label: '取締役', value: '佐藤 俊和、結川 昌憲' },
  { label: '監査役', value: '岩田 一輝' },
  { label: '株主構成', value: 'ジョルダン株式会社（100%）' },
  { label: '沿革', value: '2016年5月 設立 / 2018年2月 現社名に変更' },
  { label: '資本金', value: '2,500万円（うち資本準備金1,250万円）' }
]

export function Company() {
  return (
    <section
      id="company"
      className="section-wrapper relative overflow-hidden bg-brand-gray"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-slate-100 via-brand-gray to-white" />

      <div className="container-inner relative z-10">
        <SectionHeading subtitle="Company Profile" title="会社概要" />

        <div className="max-w-3xl mx-auto animate-on-scroll animate-on-scroll-delay-1">
          <dl className="bg-white rounded-2xl shadow-sm overflow-hidden">
            {COMPANY_INFO.map((item, i) => (
              <div
                key={item.label}
                className={`flex flex-col sm:flex-row gap-1 sm:gap-0 px-8 py-5 ${
                  i < COMPANY_INFO.length - 1 ? 'border-b border-gray-100' : ''
                }`}
              >
                <dt className="w-full sm:w-32 text-brand-blue text-sm font-semibold shrink-0">
                  {item.label}
                </dt>
                <dd className="text-gray-700 text-sm leading-relaxed">
                  {item.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  )
}
